<template>
	<div class="body">
		<header class="header-section">
			<h1 class="main-title">本月书单</h1>
      		<h1 class="main-title">📖 在阅读中沉淀更好的自己</h1>
			<div class="subtitle-wrapper">
				<span class="subtitle-badge">阅读</span>
				<span class="subtitle-badge">思考</span>
				<span class="subtitle-badge">启发</span>
			</div>
		</header>

		<section class="quote-card">
			<p class="p-highlight">你选择慢下来，与文字同行。</p>
			<p class="p-content">每一次阅读，都是一次视野的延伸。。</p>
			<div class="p-content">
				<p>当思维被打开，成长也会悄然发生。</p>
			</div>
		</section>

		<div class="wrapper">
			<div v-for="(book, index) in books" :key="index" class="book-card" :class="{ 'is-selected': selectedCourses.includes(book.title) }">
				<div class="book-header">
					<label class="custom-checkbox">
						<input type="checkbox" :value="book.title" v-model="selectedCourses" />
						<span class="checkmark"></span>
						<span class="book-title">{{ book.title }}</span>
					</label>
				</div>
				
				<div class="book-info">
					<p class="book-author">{{ book.author }}</p>
					<div class="book-desc" v-html="book.description"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		ReportData: { type: Object, required: false },
		selected: { type: Array, default: () => [] }
	},
	data() {
		return {
		selectedCourses: [],
		books: [
			{
                title: '打造第二大脑',
                author: ' 提亚戈．佛特',
                description: `本书是一本极具实用性的职场成长工具书。作者 Tiago Forte 结合多年知识管理经验，提出系统化的个人知识沉淀方法，帮助读者搭建专属的外部思维系统。`,
			},
			{
                title: '思考快与慢',
                author: '丹尼尔·卡尼曼',
                description: `本书是诺贝尔经济学奖得主丹尼尔・卡尼曼(Daniel Kahneman)的经典认知著作，也是职场人提升决策能力的必读之书。`,
			}
		]
		};
	},
	watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) { 
                this.$emit('update:selected', newVal); 
            }
		}
	},
	mounted() {
		this.selectedCourses = [...this.selected];
	}
};
</script>

<style scoped>
/* 1. 基础容器：锁定高度 */
.body {
	background:url("../../assets/26May/logo.png") right  top  no-repeat,
				url("../../assets/26May/bg.jpg")  no-repeat;
	background-size:100% 100%,cover;
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden; /* 禁止全局滚动 */
	color: #333;
	box-sizing: border-box;
	padding: 20px 0;
}

/* 2. 头部：精致化 */
.header-section {
  padding-top: 6vh;
  text-align: center;
  margin-bottom: 15px;
}
.main-title {
  font-size: 24px;
  color: #008777;
  margin: 0;
  font-weight: 800;
}
.subtitle-wrapper {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.subtitle-badge {
  font-size: 14px;
  background: #42a79d;
  color: white;
  padding: 2px 10px;
  border-radius: 20px;
  opacity: 0.8;
}

/* 3. 引用卡片：减少空间占用 */
.quote-card {
  width: 88%;
  background: rgba(255, 255, 255, 0.7);
  border-left: 4px solid #42a79d;
  padding: 12px 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}
.p-highlight {
  font-weight: bold;
  color: #42a79d;
  margin: 0 0 5px 0;
}
.p-content {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* 4. 书籍列表区域：核心滚动区 */
.wrapper {
  flex: 1; /* 自动撑开剩余空间 */
  width: 90%;
  overflow-y: auto; /* 局部滚动 */
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  /* 隐藏滚动条 (可选) */
  scrollbar-width: thin;
}

/* 5. 书籍卡片设计 */
.book-card {
  background: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.book-card.is-selected {
  border-color: #008777;
  background: #fffcfb;
  transform: translateY(-2px);
}

.book-header {
  margin-bottom: 3px;
}
.book-title {
  font-size: 18px;
  font-weight: bold;
  color: #222;
}

.book-author {
  font-size: 13px;
  color: #008777;
  background: #fef0f0;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  margin-bottom: 5px;
}
.book-desc {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  text-align: justify;
}

/* 自定义复选框样式 */
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}
.custom-checkbox input {
  display: none;
}
.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 50%;
  display: inline-block;
  position: relative;
}
.custom-checkbox input:checked + .checkmark {
  background: #008777;
  border-color: #008777;
}
.custom-checkbox input:checked + .checkmark::after {
  content: '✓';
  color: white;
  font-size: 12px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.footer-hint {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
 .body {
        background: url("../../assets/26May/pcbg.png") no-repeat center;
        background-size: cover;
    }
    .quote-card, .wrapper {
        width: 600px;
    }
    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}
</style>